// src/api/axios.ts
import axios from 'axios';
import { API_BASE_URL } from '@src/constants/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // 🔑 allow sending cookies
});

export default api;
